import type { WidgetEvent } from '@airbyte-embedded/airbyte-embedded-widget'
import { AirbyteEmbeddedWidget } from '@airbyte-embedded/airbyte-embedded-widget'

import type { ITokenResponse } from './types'

export const createTokenError = (): Error => new Error('Failed to get valid token')

export const createWidgetError = (err: unknown): Error =>
  new Error(`Widget initialization failed: ${getErrorMessage(err)}`)

const getErrorMessage = (err: unknown): string => (err instanceof Error ? err.message : 'Unknown error')

export const isValidTokenResponse = (response: unknown): response is ITokenResponse =>
  response !== null && typeof response === 'object' && 'token' in response

export const createWidget = (token: string, onSuccess?: () => void, onError?: (error: Error) => void): void => {
  const widget = new AirbyteEmbeddedWidget({
    token,
    onEvent: (event: WidgetEvent) => {
      const error = event.data?.error
      if (error) {
        onError?.(error instanceof Error ? error : new Error(String(error)))
      } else if (event.data?.success) {
        onSuccess?.()
      }
    },
  })
  widget.open()
}
